export enum ReportingFieldNames {
  START_OF_REPORTING_YEAR = 'startOfReportingYear',
  BASELINE_YEAR = 'baselineYear',
  RECALCULATION_THRESHOLD = 'recalculationThreshold',
}

export enum ReportingFieldLabels {
  START_OF_REPORTING_YEAR = 'Start of the Reporting Year',
  BASELINE_YEAR = 'Baseline Year',
  RECALCULATION_THRESHOLD = 'Baseline Year Recalculation Threshold %',
}

export enum ReportingFieldPlaceholders {
  START_OF_REPORTING_YEAR = 'Select Start of the Reporting Year',
  BASELINE_YEAR = 'Select Baseline Year',
  RECALCULATION_THRESHOLD = 'Enter Baseline Year Recalculation Threshold (%)',
}
